import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { FloorPlan } from '../types';
import { VenuePlannerApp } from '../App';

// Static constant, no auth dependencies
const FEET_TO_PIXELS = 10;

const Home: React.FC = () => {
  const navigate = useNavigate();

  // Create a default floor plan with no auth dependencies
  const defaultPlan: FloorPlan = {
    id: uuidv4(),
    name: 'New Venue',
    size: {
      width: 80 * FEET_TO_PIXELS,
      height: 60 * FEET_TO_PIXELS
    },
    items: []
  };

  return (
    <VenuePlannerApp
      floorPlan={defaultPlan}
      onSavePlan={() => {
        // Always redirect to login
        navigate('/login');
      }}
      requireAuthForSave={true}
      isLoggedIn={false} // Always false to ensure consistent behavior
    />
  );
};

export default Home; 